import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles'
import style from './AlertModal.scss';
import Button from '../Button';

const AlertModal = ({ acceptButtonText, cancelButtonText, schoolName, title, subtitle, subNote, message, handleAcceptClick, handleCancelClick }) => (
  <div className={style.modalContent}>
    <h2>{title}</h2>
    <p>
      {message ? (
        message
      ) : (
        <>
          {schoolName.length !== 0 && `${subtitle} `}
          {schoolName.length
            ? schoolName.length > 1
              ? schoolName.map(name => (
                  <ul key={'waitlist-alert-model-' + name} className={style.schoolList}>
                    <li>{name}</li>
                  </ul>
                ))
              : schoolName.map(name => <b key={'waitlist-alert-model-' + name}>{name}</b>)
            : ''}
          {subNote && `. ${subNote}`}
        </>
      )}
    </p>
    <div className={style.buttonContainer}>
      <Button label={acceptButtonText} customClass={style.confirmationButton} onClick={handleAcceptClick}>
        {acceptButtonText}
      </Button>
      <Button label={cancelButtonText} customClass={style.confirmationButton} onClick={handleCancelClick}>
        {cancelButtonText}
      </Button>
    </div>
  </div>
);

AlertModal.propTypes = {
  acceptButtonText: PropTypes.string,
  cancelButtonText: PropTypes.string,
  schoolName: PropTypes.array,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  subNote: PropTypes.string,
  message: PropTypes.string,
  handleAcceptClick: PropTypes.func,
  handleCancelClick: PropTypes.func,
};

export default withStyles(style)(AlertModal);
